import { createSlice } from '@reduxjs/toolkit';
import {
	getCountries,
	getRegions,
	getCities,
	changeUserPassword
} from '../apis/commonAPIs';
import { showSuccess } from '../../app/utils/sweetAlert';
import { t } from 'i18next';
interface CommonState {
	countries: Array<any>;
	regions: Array<any>;
	cities: Array<any>;
	languages: Array<any>;
	updatingPassword: boolean;
	header: string;
}

const initialState: CommonState = {
	countries: [],
	regions: [],
	cities: [],
	updatingPassword: false,
	header: '',
	languages: []
};

const commonSlice = createSlice({
	name: 'common',
	initialState,
	reducers: {
		setHeader(state, action) {
			state.header = action.payload;
		},
		languageFormate(state, action) {
			state.languages = action.payload;
		}
	},
	extraReducers: (builder) => {
		builder.addCase(getCountries.fulfilled, (state, action: any) => {
			state.countries = action.payload.data;
		});
		builder.addCase(getRegions.fulfilled, (state, action: any) => {
			const sortedArrayByName = action.payload.data?.sort((a: any, b: any) =>
				a.name.localeCompare(b.name)
			);
			state.regions = sortedArrayByName;
		});
		builder.addCase(getCities.fulfilled, (state, action: any) => {
			const sortedArrayByName = action.payload.data?.sort((a: any, b: any) =>
				a.name.localeCompare(b.name)
			);
			state.cities = sortedArrayByName
		});
		builder.addCase(changeUserPassword.fulfilled, (state, action: any) => {
			showSuccess({ message: t(action.payload.message) });
		});
	}
});
export const { setHeader, languageFormate } = commonSlice.actions;
export default commonSlice.reducer;
